import { AxiosResponseHeaders } from 'axios';

export interface BlobWithHeaders {
  data: Blob;
  headers: AxiosResponseHeaders;
}

export const transformBlobResponse = (data: Blob, headers: AxiosResponseHeaders): BlobWithHeaders => ({
  data,
  headers,
});
